import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

const KYCBanner = () => {
  const [showBanner, setShowBanner] = useState(true);
  
  const handleClose = () => {
    setShowBanner(false);
  };

  return showBanner && (
    <div className="position-relative py-3" style={{ background: "#f7f0e7" }}>
      <div className="d-flex flex-column align-items-center w-100">
        <span style={{ fontSize: '14px' }}>Curious about UBO, PEPs, Sanctions, or ID verification? Click here to chat with Prime about how Prime KYC can help.</span>
        <Button
          variant="outline-info"
          onClick={() => window.open("https://www.primecc.com.au/contact-us/", "_blank")}
          className="mt-2 fw-bold"
          style={{ background: '#e4ebf4', color: '#416da7', borderColor: '#cedbe5', fontSize: '12px', padding: '0.5rem 1rem' }}
        >
          Contact Us
        </Button>
        <Button
          variant="link"
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: 8,
            right: 12,
            fontSize: '1.2rem',
            padding: '0.25rem 0.5rem',
            lineHeight: 1,
            textDecoration: 'none',
            color: '#333',
          }}
          aria-label="Close"
        >
          ×
        </Button>
      </div>
    </div>
  )
};

export default KYCBanner